document.querySelectorAll('.btn[data-plg-action="donate"]')
.forEach(button => button.textContent = 'Buy a Brick')
document.querySelectorAll('.btn[href$="/brick_by_brick"]')
.forEach(button => button.textContent = 'Main Campaign')
